import React, { useContext } from "react";
import { ToastContainer, Toast as BsToast } from "react-bootstrap";
import { ToastContext } from "./ToastContext";
import { verify, error } from "../../controller/image";
import styles from "./toster.module.css";

const Toast = () => {
  const { toast, hideToast } = useContext(ToastContext);

  if (!toast.show) return null;

  const variantMap = {
    success: "success",
    error: "danger",
    warning: "warning",
    info: "info",
  };

  return (
    <ToastContainer
      position="top-end"
      className={`p-3 ${styles.toastFixed}`}
      style={{ zIndex: 3000 }}
    >
      <BsToast
        onClose={hideToast}
        show={toast.show}
        bg={variantMap[toast.type] || "primary"}
        delay={toast.delay}
        autohide
      >
        <BsToast.Body className="text-white d-flex align-items-center justify-content-between">
          <div
            className="d-flex align-items-center "
            style={{ maxWidth: "400px", wordBreak: "break-word" }}
          >
            <img
              src={toast.type === "error" ? error : verify}
              // src={}
              alt="Toast Icon"
              width={30}
              height={30}
              className="me-2 flex-shrink-0"
            />
            <strong>{toast.message}</strong>
          </div>
          <button
            type="button"
            className="btn-close ms-2 mb-1 btn-close-white"
            aria-label="Close"
            onClick={hideToast}
          ></button>
        </BsToast.Body>
      </BsToast>
    </ToastContainer>
  );
};

export default Toast;
